export default "__VITE_ASSET__C$$lr_nD__"